<template>
  <div class="counter" :class="{ absolute: !isStatic }">{{ value }}</div>
</template>

<script setup>
defineProps({
  value: {
    type: Number,
    default: 0,
  },

  isStatic: {
    type: Boolean,
    default: false,
  },
});
</script>

<style lang="scss">
.counter {
  @apply flex items-center justify-center;
  @apply text-xs leading-4 text-white-100 bg-ruby-red-100;
  @apply w-5 h-5 rounded-50%;
  right: 25px;
  top: -10px;
}
</style>
